import { Chart, registerables } from "chart.js";
import { useEffect, useRef } from "react";

Chart.register(...registerables);

const formatData = ({ data, backgroundColor } = {}) => {
  const modifiedDatasets = data?.datasets?.map((el) => ({
    backgroundColor,
    ...el,
  }));

  return {
    labels: data?.labels,
    datasets: modifiedDatasets,
  };
};

const LineChart = (props) => {
  const {
    data = [],
    height = 250,
    id = "line-chart",
    dataBgColor = "#FFB703",
  } = props;

  const chartRef = useRef(null);

  useEffect(() => {
    const createChart = (chartData) => {
      const ctx = document.getElementById(id)?.getContext("2d");
      chartRef.current = new Chart(ctx, {
        type: "line",
        data: chartData,
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              display: false,
            },
          },
          scales: {
            x: {
              border: {
                color: "#ECECEC",
                width: 2,
              },
              grid: {
                drawOnChartArea: false,
                drawTicks: false,
              },
            },
            y: {
              grace: "30%",
              border: {
                color: "#ECECEC",
                width: 2,
              },
              position: "left",
              beginAtZero: true,
              ticks: {
                stepSize: 50,
              },
              grid: {
                lineWidth: 2,
                drawTicks: false,
              },
            },
          },
        },
      });
    };

    if (chartRef.current) {
      chartRef.current.destroy();
    }

    createChart(
      formatData({
        data,
        backgroundColor: dataBgColor,
      }),
    );

    return () => {
      chartRef.current.destroy();
    };
  }, [data, dataBgColor, id, height]);

  return (
    <div className='w-full'>
      <canvas id={id} width='400' height={height}></canvas>
    </div>
  );
};

export default LineChart;
